import { FC, useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAppDispatch, useAppSelector } from '../../../hooks';
import { authSelector, logout } from '../../../store/slices';
import { SvgProfile, SvgSettings, SvgLogoutIcon } from '../../../assets/svg/general';

export const TopBar: FC = () => {
  const { user } = useAppSelector(authSelector);
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);
  const dropdownRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handleClickOutside = (e: MouseEvent) => {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target as Node)) {
        setOpen(false);
      }
    };
    if (open) document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, [open]);

  const handleLogout = () => {
    setOpen(false);
    dispatch(logout());
  };

  return (
    <div className="bg-white flex py-4 px-6 justify-end items-center border-b border-slate-medium">
      <div className="flex items-center">
        <div className="relative" ref={dropdownRef}>
          <button
            onClick={() => setOpen((prev) => !prev)}
            className="rounded-full w-8 h-8 bg-primary flex items-center justify-center flex-shrink-0 focus:outline-none"
          >
            <span className="bold text-white text-xs">
              {user?.firstName?.charAt(0)}
              {user?.lastName?.charAt(0)}
            </span>
          </button>

          {open && (
            <div className="absolute right-0 mt-2 w-60 bg-white rounded-xl shadow-lg border border-slate-medium z-50 py-2">
              <div className="flex items-center gap-3 px-4 py-3">
                <div className="rounded-full h-10 w-10 bg-primary flex-shrink-0 flex items-center justify-center">
                  <span className="bold text-white text-sm">
                    {user?.firstName?.charAt(0)}
                    {user?.lastName?.charAt(0)}
                  </span>
                </div>
                <div className="min-w-0">
                  <p className="medium text-sm text-text truncate">
                    {user?.firstName} {user?.lastName}
                  </p>
                  <p className="text-xs text-text-placeholder truncate">
                    {user?.email}
                  </p>
                </div>
              </div>

              <div className="border-t border-slate-medium my-1" />

              <button
                onClick={() => { setOpen(false); navigate('/dashboard/settings'); }}
                className="flex items-center gap-3 px-4 py-2.5 w-full text-left text-sm text-text hover:bg-neutral-200"
              >
                <SvgProfile />
                Profile
              </button>
              <button
                onClick={() => { setOpen(false); navigate('/dashboard/settings'); }}
                className="flex items-center gap-3 px-4 py-2.5 w-full text-left text-sm text-text hover:bg-neutral-200"
              >
                <SvgSettings />
                Settings
              </button>

              <div className="border-t border-slate-medium my-1" />

              <button
                onClick={handleLogout}
                className="flex items-center gap-3 px-4 py-2.5 w-full text-left text-sm text-text hover:bg-neutral-200"
              >
                <SvgLogoutIcon />
                Log out
              </button>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};
